// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Courier/pages/Route/ControlPanel/ControlPanel.module.css */
.ControlPanel_container__EBPwO {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 8px;
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 10px;
}

.ControlPanel_button__Bukww {
  width: 100%;        /* растягиваем под свою ячейку */
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.ControlPanel_button__Bukww:hover {
  background: #f5f5f5;
}

.ControlPanel_button__Bukww i {
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Courier/Route/ControlPanel/ControlPanel.module.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW,SAAS,gCAAgC;EACpD,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* src/modules/Courier/pages/Route/ControlPanel/ControlPanel.module.css */\r\n.container {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 8px;\r\n  padding: 8px;\r\n  background-color: #fafafa;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.button {\r\n  width: 100%;        /* растягиваем под свою ячейку */\r\n  background: #fff;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  padding: 8px 12px;\r\n  font-size: 0.9rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.button:hover {\r\n  background: #f5f5f5;\r\n}\r\n\r\n.button i {\r\n  font-size: 1rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ControlPanel_container__EBPwO`,
	"button": `ControlPanel_button__Bukww`
};
export default ___CSS_LOADER_EXPORT___;
